// Generated by purs version 0.14.3
"use strict";
var Control_Bind = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Bind.purs");
var Control_Monad_Except_Trans = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/transformers/v5.2.0/src/Control/Monad/Except/Trans.purs");
var Data_Functor = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Functor.purs");
var Data_Generic_Rep = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Generic/Rep.purs");
var Data_Identity = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/identity/v5.0.0/src/Data/Identity.purs");
var Foreign = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign/v6.0.1/src/Foreign.purs");
var Foreign_Generic_Class = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign-generic/v11.0.0/src/Foreign/Generic/Class.purs");
var Foreign_Internal_Stringify = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign-generic/v11.0.0/src/Foreign/Internal/Stringify.purs");
var Foreign_JSON = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign-generic/v11.0.0/src/Foreign/JSON.purs");
var genericEncode = function (dictGeneric) {
    return function (dictGenericEncode) {
        return function (opts) {
            var $10 = Foreign_Generic_Class.encodeOpts(dictGenericEncode)(opts);
            var $11 = Data_Generic_Rep.from(dictGeneric);
            return function ($12) {
                return $10($11($12));
            };
        };
    };
};
var genericEncodeJSON = function (dictGeneric) {
    return function (dictGenericEncode) {
        return function (opts) {
            var $13 = genericEncode(dictGeneric)(dictGenericEncode)(opts);
            return function ($14) {
                return Foreign_Internal_Stringify.unsafeStringify($13($14));
            };
        };
    };
};
var genericDecode = function (dictGeneric) {
    return function (dictGenericDecode) {
        return function (opts) {
            var $15 = Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Generic_Rep.to(dictGeneric));
            var $16 = Foreign_Generic_Class.decodeOpts(dictGenericDecode)(opts);
            return function ($17) {
                return $15($16($17));
            };
        };
    };
};
var genericDecodeJSON = function (dictGeneric) {
    return function (dictGenericDecode) {
        return function (opts) {
            return Control_Bind.composeKleisliFlipped(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(genericDecode(dictGeneric)(dictGenericDecode)(opts))(Foreign_JSON.parseJSON);
        };
    };
};
var encodeJSON = function (dictEncode) {
    var $18 = Foreign_Generic_Class.encode(dictEncode);
    return function ($19) {
        return Foreign_Internal_Stringify.unsafeStringify($18($19));
    };
};
var decodeJSON = function (dictDecode) {
    return Foreign_JSON.decodeJSONWith(Foreign_Generic_Class.decode(dictDecode));
};
module.exports = {
    genericDecode: genericDecode,
    genericEncode: genericEncode,
    decodeJSON: decodeJSON,
    encodeJSON: encodeJSON,
    genericDecodeJSON: genericDecodeJSON,
    genericEncodeJSON: genericEncodeJSON,
    ErrorAtIndex: Foreign.ErrorAtIndex,
    ErrorAtProperty: Foreign.ErrorAtProperty,
    ForeignError: Foreign.ForeignError,
    TypeMismatch: Foreign.TypeMismatch,
    TaggedObject: Foreign_Generic_Class.TaggedObject,
    Decode: Foreign_Generic_Class.Decode,
    Encode: Foreign_Generic_Class.Encode,
    GenericDecode: Foreign_Generic_Class.GenericDecode,
    GenericEncode: Foreign_Generic_Class.GenericEncode,
    decode: Foreign_Generic_Class.decode,
    defaultOptions: Foreign_Generic_Class.defaultOptions,
    encode: Foreign_Generic_Class.encode
};

